import React, { Component } from 'react';

// Components
import { PageSection } from '../PageSection';
import { SectionTitle } from '../generic/SectionTitle';
import { SectionText } from '../generic/SectionText';

export class Challenge extends Component {
    render() {
        return (
            <PageSection sectionId="challenge">
                <div className="inner">
                    <SectionTitle>The Challenge</SectionTitle>
                    <SectionText>
                        <p>Research conducted by RMIT University showed that plants can make people both happier and healthier.</p>

                        <p>
                            We were tasked by Horticulture Innovation Australia and partner agency, Republic of Everyone,
                            to bring the research from RMIT into an engaging digital experience that would inspire people to
                            experiment with plants in their living space and add more green in their lives!
                        </p>

                        <p>To do so, we had to overcome several challenges:</p>

                        <ul>
                            <li>There is a general lack of confidence when it comes to growing &amp; maintaining plants.</li>
                            <li>Limitations of space prevented people from buying plants.</li>
                        </ul>
                    </SectionText>
                </div>

                {this.props.children}
            </PageSection>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/sections/Challenge.jsx